import { t } from "i18next";
import { useEffect, useState } from "react";
import DBModal from "../../component/global/DBModal";
import DBSpinner from "../../component/global/DBSpinner";
import { useRequest } from "../../hooks/helperData/useRequest";
import { FEEDBACK_AI_SUMMARY_HISTORY_URL } from "../../helperData/ApiAddress";
import AiInsightBody from "../../features/ai-insight/AiInsightBody";
import {
    describeAiSummaryFilters,
    filtersFromSnapshot,
    formatSummaryDateTime,
} from "./aiSummaryFilters";

export default function MessagesAiSummaryHistoryModal({ show, onHide }) {
    const [rows, setRows] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [getHistory, loading] = useRequest(
        FEEDBACK_AI_SUMMARY_HISTORY_URL,
        "GET"
    );

    useEffect(() => {
        if (!show) return undefined;
        let cancelled = false;
        setLoaded(false);
        getHistory()
            .then((payload) => {
                if (cancelled) return;
                setRows(Array.isArray(payload) ? payload : []);
                setLoaded(true);
            })
            .catch(() => {
                if (cancelled) return;
                setRows([]);
                setLoaded(true);
            });
        return () => {
            cancelled = true;
        };
    }, [show]);

    return (
        <DBModal
            permanent
            show={show}
            minWidth={720}
            onHide={onHide}
            className="messages-ai-summary-modal messages-ai-history-modal"
            ariaLabelledby="messages-ai-history-title"
        >
            <DBModal.Header
                closeBtn={onHide}
                closeLabel={t("Organizational.Messages.AiSummary.Close")}
                title={
                    <span id="messages-ai-history-title">
                        {t("Organizational.Messages.AiSummary.History")}
                    </span>
                }
            />
            <DBModal.Content>
                {loading && !loaded ? (
                    <div className="messages-ai-history__loading">
                        <DBSpinner />
                    </div>
                ) : rows.length === 0 ? (
                    <p className="survey-form-help">
                        {t("Organizational.Messages.AiSummary.HistoryEmpty")}
                    </p>
                ) : (
                    <ol className="messages-ai-history">
                        {rows.map((row) => {
                            const filters = filtersFromSnapshot(
                                row.filter_snapshot
                            );
                            const chips = describeAiSummaryFilters(filters, t);
                            const generatedAt =
                                row.jalali_generated_at || row.generated_at;
                            return (
                                <li key={row.id} className="messages-ai-history__item">
                                    <AiInsightBody
                                        headline={row.headline}
                                        summary={row.summary}
                                        highlights={row.highlights}
                                        metaItems={[
                                            generatedAt && {
                                                id: "generated",
                                                text: t(
                                                    "Organizational.Messages.AiSummary.GeneratedAt",
                                                    {
                                                        date: formatSummaryDateTime(
                                                            generatedAt
                                                        ),
                                                    }
                                                ),
                                            },
                                            row.matched_count != null && {
                                                id: "included",
                                                text: t(
                                                    "Organizational.Messages.AiSummary.Included",
                                                    {
                                                        included:
                                                            row.included_count,
                                                        matched:
                                                            row.matched_count,
                                                    }
                                                ),
                                            },
                                        ]}
                                    />
                                    <ul className="messages-ai-summary__chips">
                                        {(chips.length
                                            ? chips
                                            : [
                                                  {
                                                      id: "all",
                                                      label: t(
                                                          "Organizational.Messages.AiSummary.HistoryAll"
                                                      ),
                                                  },
                                              ]
                                        ).map((chip) => (
                                            <li key={chip.id}>{chip.label}</li>
                                        ))}
                                    </ul>
                                </li>
                            );
                        })}
                    </ol>
                )}
            </DBModal.Content>
        </DBModal>
    );
}
